// Action Types
export const SUBMIT_CLOSURE_REQUEST = "SUBMIT_CLOSURE_REQUEST";
export const SUBMIT_CLOSURE_SUCCESS = "SUBMIT_CLOSURE_SUCCESS";
export const SUBMIT_CLOSURE_FAILURE = "SUBMIT_CLOSURE_FAILURE";

// Action Creators
export const submitClosureRequest = (formData) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_CLOSURE_REQUEST,
      payload: formData,
    });
  };
};

export const submitClosureSuccess = (message) => ({
  type: SUBMIT_CLOSURE_SUCCESS,
  payload: message,
});

export const submitClosureFailure = (error) => ({
  type: SUBMIT_CLOSURE_FAILURE,
  payload: error,
});